import { useQuery } from '@tanstack/react-query';
import { Metadata_Service } from './';
import { GetClusterAdminInfoResponse } from '../types/tecton_proto/metadataservice/metadata_service';

const fetchGetClusterAdminInfo = async () => {
  const { data } = await Metadata_Service('get-cluster-admin-info', {});
  const responseJson: GetClusterAdminInfoResponse = data;

  if (responseJson == null) {
    return null;
  }

  // Return the same structure as the old MetadataService for compatibility
  return {
    isAdmin: responseJson.caller_is_admin ?? false,
    users: responseJson.users ?? [],
    admins: responseJson.admins ?? [],
  };
};

export const useGetClusterAdminInfo = () => {
  return useQuery(['get-cluster-admin-info'], fetchGetClusterAdminInfo);
};
